const PublishState = {
  PUBLISHED: 'PUBLISHED',
  PUBLISHED_WITH_DRAFT: 'PUBLISHED_WITH_DRAFT',
  DRAFT: 'DRAFT'
};
export default PublishState;